import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/uni_modules/qiun-data-charts/components/qiun-loading/loading2.vue'
wx.createComponent(Component)